<template>
  <div>
    <div class="topHeader fixed" :class="navbarFixed?'fixed':''" v-bind:style="{height:headerHeight}">
      <div class="icon-back" @click="backClick()" v-if="backShow">
        <img src="/static/images/works/store_button_back_pressed_2x.png" alt>
      </div>
      <div class="time-box">{{navbartitle}}</div>
      <img src="/static/images/works/h5_icon_service.png" alt="" class="h5_icon_service" v-if="serviceShow" @click="clickopenService">
    </div>
    <div v-bind:style="{height:headerHeight}"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      navbarFixed: false,
      originHeight: 0,
      backShow: true,
      headerHeight:''
    };
  },

  props: { navbartitle: { required: true }, backShow: { default: true }, serviceShow:''},
  created() {
    let deviceType = localStorage.getItem('device');
    console.log("deviceType",deviceType);
    if(deviceType === "iphoneX"){
      this.headerHeight = "84px";
    }else{
      this.headerHeight = "64px";
    }
    console.log("顶部导航");
  },

  mounted() {
    // window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    // window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector(".topHeader").offsetTop;
      this.originHeight =
        this.originHeight == 0 ? offsetTop : this.originHeight;
      if (scrollTop > this.originHeight) {
        this.navbarFixed = true;
      } else {
        this.navbarFixed = false;
      }
    },
    backClick() {
      this.$emit("backClick", true);
    },
    clickopenService() {
      this.deviceType=localStorage.getItem('device');
      console.log(this,'this',this.deviceType)
      if (this.deviceType === "iphoneX" || this.deviceType === "iphoneOther") {
        window.webkit.messageHandlers.AppModel.postMessage({
          body: "openService",
          isAlert: "false"
        });
      } else if (this.deviceType === "android") {
        window.nativeMethod.openService();
      }
    },
  }
};
</script>
<style scoped>
.topHeader {
  background: #fff;
  display: flex;
  justify-content: space-between;
}
.fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
}
.time-box {
  display: inline-block;
  margin: auto auto 10px auto;
  width: 195px;
  height: 28px;
  line-height: 28px;
  border-radius: 14px;
  font-size: 18px;
  color: rgba(66, 66, 66, 1);
  text-align: center;
}
.icon-back {
  width: 22px;
  height: 22px;
  position: absolute;
  left: 15px;
  bottom: 11px;
}
.icon-back img {
  width: 11px;
  height: 20px;
}
.fixed_height {
  height: 64px;
}
.h5_icon_service{
  width: 22px;
  height: 20px;
  position: absolute;
  right: 18px;
  bottom: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/navBar.vue